var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8E8E8E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.757 0H5.243A5.25 5.25 0 0 0 0 5.243v8.514A5.25 5.25 0 0 0 5.243 19h8.514A5.25 5.25 0 0 0 19 13.757V5.243A5.25 5.25 0 0 0 13.757 0zm3.557 13.757a3.562 3.562 0 0 1-3.557 3.557H5.243a3.561 3.561 0 0 1-3.557-3.557V5.243a3.562 3.562 0 0 1 3.557-3.557h8.514a3.562 3.562 0 0 1 3.557 3.557v8.514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.104 3.958a5.152 5.152 0 0 0-5.146 5.146 5.152 5.152 0 0 0 5.146 5.146 5.152 5.152 0 0 0 5.146-5.146 5.152 5.152 0 0 0-5.146-5.146zm0 8.42A3.278 3.278 0 0 1 5.83 9.105 3.278 3.278 0 0 1 9.104 5.83a3.278 3.278 0 0 1 3.275 3.274 3.278 3.278 0 0 1-3.275 3.275zM14.646 3.167a1.192 1.192 0 0 0-1.188 1.187c0 .312.128.619.349.84.22.22.527.348.839.348a1.2 1.2 0 0 0 .84-.348 1.193 1.193 0 0 0 0-1.68 1.193 1.193 0 0 0-.84-.347z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.da375b50f3551af0bd6d5050352d7a13.svg";
export { ForwardRef as ReactComponent };